import { notifyHiveOnboarding } from "../../../../../services/monitoring/discordNotifications";

const IP_GETTER_URL = 'https://api.ipify.org?format=json';


const getIpInfo = async () => {
  let ip = '';
  try {
    const response = await fetch(IP_GETTER_URL);
    const data = await response.json();
    ip = data.ip;
  } catch (error) {
    console.error('Error fetching IP address:', error);
  }
  return ip;
};

const getBrowserInfo = () => {
  const { userAgent, platform, language } = window.navigator;
  const localeTime = new Date().toLocaleString();
  return ({ userAgent, platform, language, localeTime });
};


export const trackOnboarding = async (msg) => {
  // browser
  let browserInfo;
  try {
    browserInfo = await getBrowserInfo();
  } catch (err) {
    console.error('Something broke preparing browser info:', err);
  }
  // ip
  let ipInfo;
  try {
    ipInfo = await getIpInfo();
  } catch (err) {
    console.error('Something broke preparing ip info:', err);
  }
  // result
  const { userAgent, platform, language, localeTime } = browserInfo;
  const info = { userAgent, platform, language, localeTime, ip: ipInfo };
  // notification
  notifyHiveOnboarding({ msg, data: info });
};
